import { ServiceStockParentService } from './service-stock-parent.service';
import { Injectable, NgZone } from '@angular/core';
import { ProvidehttpService } from './providehttp.service';
import { Data } from './DataService';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AlertsService } from './AlertsService';
import { DomSanitizer } from '@angular/platform-browser';
import { RoutingService } from './routing-service';
import { ToasterServices } from './ToasterServices';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { ThemeServices } from './ThemeServices';
import { TxTimePipe } from './gotx/components/TxTime/tx-time.pipe';
import { HttpResponse } from '@angular/common/http';
// import { MtasService } from './mtas-service';
import { UserPreference, MarketWatchPreferenceInfo } from './user-preference.model';
import { Observable } from 'rxjs';



export interface columnType {
  text: any;
  id: string;
  checked: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ServiceStock extends ServiceStockParentService {
  windowSizeMap = new Map();
  modalRef: any;
  retValue: number = 0;


  private stmntColumnsData: columnType[] = [
    { text: 'Exchange', id: 'exchange', checked: true },
    { text: 'Product', id: 'product', checked: true },
    { text: 'Collateral', id: 'balancesMargin', checked: true },
    { text: 'USBought', id: 'balancesUnderSettleBought', checked: true },
    { text: 'USSold', id: 'balancesUnderSettleSold', checked: true },
    { text: 'CSBought', id: 'balancesCurrentSettlBought', checked: true },
    { text: 'CSSold', id: 'balancesCurrentSettlSold', checked: true },
    { text: 'CSE', id: 'lmtMaxAvailForSale', checked: true },
    { text: 'NetQty', id: 'balanceNetQty', checked: true },
    { text: 'AvgPrice', id: 'stockAvgPrice', checked: true },
    { text: 'LTP', id: 'lastTradePrice', checked: true },
    { text: 'MarketValue', id: 'balanceMarketValue', checked: true },
    { text: 'Realised', id: 'realisedProfitLoss', checked: true },
    { text: 'Unrealised', id: 'unRealisedProfitLoss', checked: true }
  ];
  MessageParser: any;
  DataService: any;
  Utils: any;
  MessageBox: any;


  constructor(public routing: RoutingService,
    public http: ProvidehttpService,
    public dataStore: Data,
    public modal: NgbModal,
    public translate: TranslateService,
    public theme: ThemeServices,
    // public mtas: MtasService,
    public router: Router,
    public alert: AlertsService,
    public ngZone: NgZone,
    public sanitizer: DomSanitizer,
    public toast: ToasterServices,
    public authService: AuthService,
    public timePipe: TxTimePipe,
    public UserPreference: UserPreference,
    public MarketWatchPreferenceInfo: MarketWatchPreferenceInfo) {
    super(routing, http, dataStore, modal, translate, theme, router, alert, ngZone, sanitizer);
    this.windowSizeMap.set('Buying Power Summary', 'limit');
    this.windowSizeMap.set('Trade Positions', 'positionWin');
    this.windowSizeMap.set('Market News', 'newsWin');
    this.windowSizeMap.set('Notification', 'notificationsWin');
    this.windowSizeMap.set('Order Book', 'orderBookWin');
    this.windowSizeMap.set('Trade Book', 'positionWin');
    this.windowSizeMap.set('Watchlist', 'Watchlist');
    this.windowSizeMap.set('Change Password', 'ChangePassword');
    this.windowSizeMap.set('Buy', 'orderEntry');
    this.windowSizeMap.set('Sell', 'orderEntry');
    this.windowSizeMap.set('OrderEntry', 'orderEntry');
    this.windowSizeMap.set('Market Watch Edit Columns', 'editColumns');
    this.windowSizeMap.set('Market Depth Matrix', 'depthMatrix');
    this.windowSizeMap.set('User Preference', 'UserPreference');
    this.windowSizeMap.set('Derivative Position Margin', 'EqDerWin');
    this.windowSizeMap.set('PNL Calculator', 'PNLCalculatorWin');

    // this.stmntColumnsData = []

  }
  custumFormatAmount(input, input2) {
    //
    return 'something';
  }
  getEnvironment() {
    return environment;
  }


  public logoutFinal(): Observable<number> {
    console.log('Auth Service logout');

    const inputMap = new Map();

    return new Observable<number>((observer) => {
      this.http.fetchApi('/auth/logout', 'POST', inputMap).subscribe(
        (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          var respCode: any = res['respCode'];

          if (respCode != null && respCode == 0) {
            console.log('in if block');
            this.retValue = 0;
            this.dataStore.clearAll();
            this.http.sessionValid = false;
            this.http.oeLoggedIn = false;
            this.http.loggedIn = false;
            this.authService.newUserValue = null;

            localStorage.removeItem('userID');
            sessionStorage.clear();

            this.router.navigate(['/login']);

            observer.next(0);
          } else {
            console.log('in else block');
            observer.next(-1);
          }

          observer.complete();
        },
        (httpError) => {
          console.error('Logout error', httpError);
          this.retValue = -1;
          observer.error(-1);
        }
      );
    });
  }

  /*async logout() { // If you are updating anything here then update that in Auth Guard also by Mirsha
    // this.authService.logout();
   this.logoutFinal();
  this.dataStore.clearAll();
    this.http.sessionValid = false;
    this.http.oeLoggedIn = false;
    this.http.loggedIn = false;
    this.authService.newUserValue = null;
    localStorage.removeItem('userID');
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }*/

  async logout(): Promise<number> {
    try {
      const result = await this.logoutFinal().toPromise();

      if (result === 0) {
        console.log('Logout successful');
      } else {
        console.log('Logout failed');
      }
      return result;
    } catch (error) {
      console.log('Logout failed with error');
      return -1;
    }
  }

  openModal(component, size: 'sm' | 'lg' | 'xl', params, popup) {
    // console.log("params",params);
    // console.log("popup",popup);
    if (this.windowSizeMap.get(popup)) {
      size = this.windowSizeMap.get(popup);
    }

    let keyboardCtrl = true;
    if (popup == "Gotx Popup") {
      keyboardCtrl = false;
    }
    // console.log("----Window size" ,size);
    if (this.modal.hasOpenModals()) {
      this.modal.dismissAll();
    }
    this.modalRef = this.modal.open(component,
      {
        ariaLabelledBy: 'modal-basic-title',
        size: size,
        scrollable: true,
        windowClass: 'myCustomModalClass',
        keyboard: keyboardCtrl,
        backdrop: 'static'
      });

    // let params = {
    //   title: 'Alert',
    //   message: 'Session Expired',
    //   buttonTxt: 'OK'
    // }

    this.modalRef.componentInstance.selectedMenu = popup;
    this.modalRef.componentInstance.params = params;

    return this.modalRef;
  }
  transalte(text) {
    return this.translate.instant(text);
  }



  public getColumnsArray(): columnType[] {
    return this.stmntColumnsData.slice();
  }

  public updateArray(id: string, checkedStatus: boolean) {
    for (let i = 0; i < this.stmntColumnsData.length; i++) {
      if (this.stmntColumnsData[i].id == id) {
        this.stmntColumnsData[i].checked = checkedStatus;
        break;
      }
    }
  }



}
